import { PublicFormRenderer } from "@/components/forms/PublicFormRenderer";

export function FormBlock({ content }: { content: Record<string, unknown> }) {
  const slug = String(content.slug ?? "");

  return (
    <section className="mx-auto max-w-2xl px-4 py-10">
      <PublicFormRenderer slug={slug} />
    </section>
  );
}
